export const IS_DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';
